/*
 * Module for the Vendor Payroll Trial job criteria page
 */
rs.module("content/jobs/criteria/vendorpayrolltrial",

    [
        "controls/components/event-banner",
        "controls/data/grid",
        "common/visibility"
    ],

    function (eventBanner, gridModule, visibility) {

        var _vendorsAvailable;

        // Initialize the page
        function initialize(jsSelectors, lrsGridApi, anyVendors, backendUrl) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var paymentDateInput = criteria.js(jsSelectors.paymentDateInput);
            var transactionDateInput = criteria.js(jsSelectors.transactionDateInput);
            var vendorsSection = criteria.js(jsSelectors.vendorsSection);
            var loadingSpinner = criteria.js(jsSelectors.loadingSpinner);

            // Default _vendorsAvailable
            _vendorsAvailable = anyVendors;

            // Re-populate state drop down options
            paymentDateInput.change(_.debounce(function () {
                dateChanged();
            }, 500));

            transactionDateInput.change(_.debounce(function () {
                reloadVendors();
            }, 500));

            // Listen for a date change and determine grid visibility.
            function dateChanged() {

                if (paymentDateInput.val() && paymentDateInput.valid() && transactionDateInput.val() && transactionDateInput.valid() && _vendorsAvailable) {
                    visibility.show(vendorsSection);
                }
                else {
                    lrsGridApi.selectedValues = null;
                    visibility.hide(vendorsSection);
                }
            }

            // Hookup ajax to changing transaction date to repopulate the grid.
            function reloadVendors() {

                // Remove mesages
                eventBanner.removeAllMessages();

                // Clear selections
                lrsGridApi.selectedValues = null;

                if (transactionDateInput.val() && transactionDateInput.valid()) {

                    loadingSpinner.show();

                    gridModule.update(
                        backendUrl,

                        { transactionAsOfDate: transactionDateInput.val() },

                        lrsGridApi.agGridApi,

                        function done(gridUpdate) {

                            _vendorsAvailable = true;

                        }).fail(function (jqXHR, textStatus, errorThrown) {

                            _vendorsAvailable = false;
                            lrsGridApi.selectedValues = null;

                        }).always(function () {

                            loadingSpinner.hide();
                            dateChanged();

                        });
                }
                else {
                    _vendorsAvailable = false;
                    dateChanged();
                }
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);